import { useSnapshot } from "valtio";

import React from "react";

import { KioskAppLogoSvgIcon } from "@components/SvgIcons/KioskAppLogoSvgIcon";
import { syncStore } from "@components/Synchronization/store";

export function LocalSettingsHeader(): JSX.Element {
    const { selectedEntityChild, selectedShopApp } = useSnapshot(syncStore);

    return (
        <div
            style={{
                background: "linear-gradient(135deg, #1f2937 0%, #111827 100%)",
                borderRadius: "20px 20px 0 0",
                padding: "2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 4px 20px -2px rgba(0, 0, 0, 0.1)",
                border: "1px solid #374151",
                borderBottom: "none",
                position: "relative",
                overflow: "hidden",
                marginBottom: "3rem",
            }}
        >
            {/* Background accent */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background:
                        "linear-gradient(90deg, #077dbc 0%, #065a94 50%, #077dbc 100%)",
                }}
            />

            {/* Left section - Logo */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "2rem",
                }}
            >
                <div
                    style={{
                        padding: "1rem",
                        background: "rgba(255, 255, 255, 0.05)",
                        borderRadius: "16px",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        backdropFilter: "blur(10px)",
                    }}
                >
                    <KioskAppLogoSvgIcon width="200" height="80" />
                </div>

                {/* Separator */}
                <div
                    style={{
                        height: "80px",
                        width: "1px",
                        background:
                            "linear-gradient(to bottom, transparent, #4b5563, transparent)",
                    }}
                />
            </div>

            {/* Center section - App info */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0.5rem",
                    flex: 1,
                    paddingLeft: "2rem",
                }}
            >
                <div
                    style={{
                        color: "#ffffff",
                        fontSize: "24px",
                        fontWeight: "700",
                        letterSpacing: "1px",
                        textAlign: "center",
                        fontFamily: "Segoe UI, sans-serif",
                        textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
                    }}
                >
                    {selectedEntityChild?.name}
                </div>
                <div
                    style={{
                        color: "#d1d5db",
                        fontSize: "18px",
                        fontWeight: "500",
                        letterSpacing: "0.5px",
                        textAlign: "center",
                        fontFamily: "Segoe UI, sans-serif",
                        opacity: 0.9,
                    }}
                >
                    {selectedShopApp.name as string}
                </div>
            </div>
        </div>
    );
}
